import styled from 'styled-components'

export const ListWrap = styled.ul``
